import { render, staticRenderFns } from "./UserMpQrcode.vue?vue&type=template&id=86588bdc&"
import script from "./UserMpQrcode.vue?vue&type=script&lang=js&"
export * from "./UserMpQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports